import styled from "styled-components";

import { FlexColumn, PopoverContent } from "@similarweb/ui-components";

export const StyledPopoverContent = styled(PopoverContent)`
    padding: 0;
    max-height: 384px;
    z-index: 1000;
    width: 900px;
    overflow-y: auto;
`;

export const StyledPopoverContentBody = styled.div`
    max-height: 280px;
    overflow-y: auto;
`;

export const StyledCompanyPlaceholderText = styled.span`
    margin-left: 36px;
`;

export const StyledQuota = styled.div`
    z-index: 3;
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
`;

export const StyledAutocompleteLowBannerWrapper = styled(FlexColumn)`
    padding: 8px;
`;
